module.exports = __webpack_public_path__ + "placa_moveis_10x_s_entr_s_juros.png?499bea87b0370c0ca31ff073215a7a40";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/placa_moveis_10x_s_entr_s_juros.png
// module id = 128
// module chunks = 0